<template>
  <div>
    <span v-if="showModal">
      <v-dialog
        v-model="showModal"
        :max-width="windowWidth"
        scrollable
        :retain-focus="false"
        @input="onInput"
        @click:outside="onClickOutSize"
      >
      <v-container fluid class="px-0 py-0">
        <v-toolbar>
          <v-btn
            small
            elevation="0"
            @click.stop="onOpenAsPage"
          >
            <v-icon
              left
            >
              mdi-arrow-top-right-bottom-left
            </v-icon>
            Open as page
          </v-btn>
        </v-toolbar>
        <v-card>
          <slot></slot>
        </v-card>
      </v-container>
    </v-dialog>
    </span>
    <span v-else>
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  components: {
  },

  watch: {
    $router: {
      immediate: true,
      handler: function (newVal, oldVal) {
        // console.log('router watch', this.showModal, newVal, oldVal)
        this.showModal = newVal.currentRoute !== null &&
            newVal.currentRoute.hasOwnProperty('meta') &&
            newVal.currentRoute.meta !== null &&
            newVal.currentRoute.meta.showModal === true
        // console.log('router watch 1', this.showModal, newVal.currentRoute.name, newVal, oldVal)
      }
    }
  },

  async mounted() {
    // console.log('BaseModal mounted', this.$router.currentRoute)
  },

  methods: {
    onRouterChange(newVal, oldVal) {
      this.showModal = newVal !== null && newVal.meta !== null && newVal.meta.showModal
      // console.log('$router', newVal, this, this.showModal)
    },
    onInput(event) {
      let names = this.$router.currentRoute.name.split('_')
      names.pop()
      let name = names.join('_')
      this.$router.push({name: name})
    },
    onClickOutSize(event) {
      this.onInput(event)
    },
    onOpenAsPage() {
      const name = this.$router.currentRoute.name.split('_').pop()
      const params = this.$router.currentRoute.params
      const routeAsPage = {name: name, params: params}
      this.$router.replace(routeAsPage)
    },
  },
  data() {
    return {
      showModal: this.$router.currentRoute !== null &&
            this.$router.currentRoute.hasOwnProperty('meta') &&
            this.$router.currentRoute.meta !== null &&
            this.$router.currentRoute.meta.showModal === true,
      windowHeight: (window.innerHeight) * 0.8,
      windowWidth: (window.innerWidth) * 0.9,
    }
  },
};
</script>

<style  scoped lang="scss">
</style>
